import type { Account, ECampaignClass } from '@feathr/blackbox';
import { CampaignClass, FacebookIntegrationState as MetaIntegrationState } from '@feathr/blackbox';

export function assertCampaignClassKey(key?: string): asserts key is keyof typeof ECampaignClass {
  if (key === undefined) {
    throw new Error(`Campaign class key not found for ${key}`);
  }
}

interface IValidatorProps {
  cls: CampaignClass;
  account: Account;
}

export function hasEmailSendingErrors({ cls, account }: IValidatorProps): boolean {
  const emailSendingSuspended = account.get('email_health') === 'suspended';
  const isEmailCampaign = [
    CampaignClass.AutoPinpointEmail,
    CampaignClass.PinpointEmail,
    CampaignClass.SmartPinpointEmail,
    CampaignClass.Drip,
  ].includes(cls);

  return emailSendingSuspended && isEmailCampaign;
}

export function hasMetaIntegrationErrors({ cls, account }: IValidatorProps): boolean {
  const integrationState = account.get('facebook').state;
  if (![CampaignClass.Facebook, CampaignClass.EmailListFacebook].includes(cls)) {
    return false;
  }

  if (integrationState === MetaIntegrationState.not_connected) {
    return true;
  }

  // Connecting Facebook Page is required to launch Facebook campaigns
  if (integrationState === MetaIntegrationState.no_page_selected) {
    return true;
  }

  // Account must accept Custom Audience ToS to launch Facebook Email List campaigns
  if (
    cls === CampaignClass.EmailListFacebook &&
    !account.get('facebook').tos_accepted.custom_audience_tos
  ) {
    return true;
  }

  return false;
}
